import * as React from "react";
const ContactCMView = React.lazy(() => import("./ContactCMViewContainer"));

export { ContactCMView };
